import React from 'react'
import { object, bool } from 'prop-types'
import { connect } from 'react-redux'
import Loading from 'bisu-react-loading'

import Container from './container'
import { fetchLedger } from './actions'

const LedgerShow = ({ __hasFetched, __item }) => {
  if (!__hasFetched) {
    return <Loading />
  }

  return (
    <Container data={__item} />
  )
}

LedgerShow.onEnter = (store) => (nextState) =>
  store.dispatch(fetchLedger(Number(nextState.params.studentID)))

LedgerShow.propTypes = {
  __hasFetched: bool,
  __item: object,
}

function mapStateToProps(state) {
  return {
    __hasFetched: state.ledger.get('hasFetched'),
    __item: state.ledger.get('item'),
  }
}
export default connect(mapStateToProps)(LedgerShow)



// WEBPACK FOOTER //
// ./src/containers/Ledger/show.js